import React from 'react';
import { TypingIndicatorProps } from '../types';
import './TypingIndicator.css';

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  typingUsers,
  currentUser
}) => {
  // Filter out current user from typing users
  const otherTypingUsers = Array.from(typingUsers).filter(user => user !== currentUser);

  if (otherTypingUsers.length === 0) {
    return null;
  }

  // Format typing message based on number of users
  const getTypingMessage = () => {
    if (otherTypingUsers.length === 1) {
      return `${otherTypingUsers[0]} is typing...`;
    } else if (otherTypingUsers.length === 2) {
      return `${otherTypingUsers[0]} and ${otherTypingUsers[1]} are typing...`;
    } else {
      return `${otherTypingUsers[0]} and ${otherTypingUsers.length - 1} others are typing...`;
    }
  };

  return (
    <div className="typing-indicator" role="status" aria-live="polite">
      <div className="typing-indicator__content">
        <div className="typing-indicator__dots">
          <span className="typing-indicator__dot"></span>
          <span className="typing-indicator__dot"></span>
          <span className="typing-indicator__dot"></span>
        </div>
        <span className="typing-indicator__text">
          {getTypingMessage()}
        </span>
      </div>
    </div>
  );
};